<template>

    <main class="card hidden_overflow_tabela px-1">
        <validation-observer>
            <b-form>
                <b-row class="align-items-center">
                    <b-col sm="6" lg="6" class="px-2">
                        <b-form-group label="Nome da Dose" label-for="descricao" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="descricao">
                                <b-form-input id="descricao" v-model="form.descricao"
                                    placeholder="Insira o nome da dose" autocomplete="off" maxlength="255">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-input>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col sm="6" lg="3" class="px-2">
                        <b-form-group label="Código da Dose" label-for="codigo" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="codigo">
                                <b-form-input id="codigo" v-model="form.codigo" placeholder="Insira o código da dose"
                                    autocomplete="off" v-mask="'##########'" maxlength="10">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-input>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col sm="6" lg="3" class="px-2">
                        <b-form-group label="Status" label-for="status" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="status">
                                <v-select id="status" v-model="form.status" :options="statusOptions"
                                    :reduce="option => option.value" placeholder=" Selecione o status" label="label"
                                    item-text="status" item-value="status" :clearable="true">
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </v-select>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                </b-row>
            </b-form>
        </validation-observer>
        <Filters @actionSearch="search" @actionClear="clear" />

        <b-row align-h="between">
            <b-col lg="6" md="6" sm="6">
                <div class="d-flex justify-center-center align-items-center">
                    <span class="mr-1" for="tableSize">Mostrar</span>
                    <v-select id="tableSize" v-model="defaultSize" :options="optionsSize" :clearable="false"
                        class="customizeDifferentSpace" @input="fireEventFilter(false, true)" style="width: 87px;">
                        <span slot="no-options">Nenhuma opção selecionável.</span>
                    </v-select>
                </div>
            </b-col>
          <b-col  lg="6" md="6" sm="6">
            <ButtonDownloadSpreadsheet type="Doses" :parameters="parameters" :size="paginationTotalLines"
                                       :isEmpty="tableItemsLength === 0" tooltip-text="Exportar doses" />
          </b-col>
        </b-row>
    </main>

</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BForm, BCol, BRow, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { setListFilter } from '@core/utils/store/setStore'
import Filters from '@/views/components/custom/filters/Filters.vue'
import ButtonDownloadSpreadsheet from "@/views/components/button-download-spreadsheet/ButtonDownloadSpreadsheet.vue";

export default {
    components: {
      ButtonDownloadSpreadsheet,
        ValidationObserver,
        ValidationProvider,
        Filters,
        vSelect,
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
    },
    props: {
        filter: {
            required: true,
            type: Boolean,
        },
        parameters: {
          type: Object,
          required: false,
        },
        paginationTotalLines: {
          type: Number,
          required: false,
        },
        tableItemsLength: {
          type: Number,
          required: false,
        },
    },
    data() {
        return {
            defaultSize: 10,
            optionsSize: [10, 25, 50, 100],
            searchFilter: {},
            form: {
                descricao: '',
                codigo: '',
                status: '',
            },
            statusOptions: [
                { label: 'Ativo', value: true },
                { label: 'Inativo', value: false }
            ],
        }
    },
    watch: {
        filter() {
            this.fireEventFilter()
        },

        defaultSize() {
            this.$emit('defaultSizeChanged')
        },
    },
    mounted() {
        this.fireEventFilter(true, false)
    },
    methods: {
        fireEventFilter(first = false, changeSize = false) {
            const listFilter = {
                descricao: this.form.descricao,
                br_dose: this.form.codigo,
                ativo: this.form.status,
                defaultSize: this.defaultSize,
                route: this.$router.currentRoute.name,
            }

            if (changeSize) { listFilter.currentPage = 1 }
            if (!first) { setListFilter(listFilter) }

            this.searchFilter = {
                tamanho: this.defaultSize,
                route: this.$router.currentRoute.name,
                descricao: this.form.descricao,
                br_dose: this.form.codigo,
                ativo: this.form.status,
                defaultSize: this.defaultSize,
            }
            this.$emit('filterTable', this.searchFilter)
        },

        search() {
            this.searchFilter = {
                defaultSize: this.defaultSize,
                route: this.$router.currentRoute.name,
                descricao: this.form.descricao,
                br_dose: this.form.codigo,
                ativo: this.form.status,
                clear: false,
                tamanho: this.defaultSize,
                pagina: 1,
            }

            this.$emit('filterTable', this.searchFilter)
        },

        clear() {
          this.form.descricao = ''
          this.form.codigo = ''
          this.form.status = ''

          this.defaultSize = 10

          this.searchFilter = {
            defaultSize: this.defaultSize,
            route: this.$router.currentRoute.name,
            pagina: 1,
            tamanho: this.defaultSize,
            currentPage: 1,
            clear: true,
          }

          this.$emit('filterTable', this.searchFilter)
        },
    },
}

</script>